/* eslint-disable no-unused-vars */
import { ref, computed } from 'vue';
import { DELIVERY_TEXTS } from '../../constants/delivery.ts';

export enum DeliveryStatus {
    AVAILABLE = 'available',
    UNAVAILABLE = 'unavailable',
    UNKNOWN = 'unknown',
}
/* eslint-enable no-unused-vars */

export interface IDeliveryStore {
    name: string;
    warehouseCode: string;
}

export function useFastDeliveryStatus() {
    const availableDeliveryStatus = ref<DeliveryStatus>(DeliveryStatus.UNKNOWN);
    const processCheckingAddress = ref<boolean>(false);
    const nearestStore = ref<string>('');
    const warehouseCode = ref<string>('');

    const availableDeliveryText = computed(() => {
        switch (availableDeliveryStatus.value) {
            case DeliveryStatus.AVAILABLE:
                return DELIVERY_TEXTS.FAST_DELIVERY.AVAILABLE_AT_ADDRESS;
            case DeliveryStatus.UNAVAILABLE:
                return DELIVERY_TEXTS.STANDARD_DELIVERY.ONLY_STANDARD;
            case DeliveryStatus.UNKNOWN:
                return DELIVERY_TEXTS.ADDRESS.ENTER_OR_POINT;
        }
        return '';
    });

    const availableDeliveryIcon = computed(() => {
        if (processCheckingAddress.value) {
            return 'spinner';
        }

        switch (availableDeliveryStatus.value) {
            case DeliveryStatus.AVAILABLE:
                return 'ok';
            default:
                return 'info';
        }
    });

    const checkDeliveryAvailability = async (
        coordinates: { lat: string; lng: string },
        callbackCheckCoords: Function
    ) => {
        processCheckingAddress.value = true;

        try {
            const { data } = await callbackCheckCoords(coordinates);

            availableDeliveryStatus.value = data.success
                ? DeliveryStatus.AVAILABLE
                : DeliveryStatus.UNAVAILABLE;

            const store = !data.stores || data.stores.length === 0
                ? null
                : data.stores[0];

            if (store) {
                nearestStore.value = store.name;
                warehouseCode.value = store.warehouseCode;
            }

            return { success: data.success, store };
        } finally {
            processCheckingAddress.value = false;
        }
    };

    const setDeliveryStatus = (status: DeliveryStatus) => {
        availableDeliveryStatus.value = status;
    };

    const setNearestStore = (store: string) => {
        nearestStore.value = store;
    };

    const resetDeliveryStatus = () => {
        availableDeliveryStatus.value = DeliveryStatus.UNKNOWN;
        nearestStore.value = '';
        warehouseCode.value = '';
    };

    return {
        availableDeliveryStatus,
        processCheckingAddress,
        nearestStore,
        warehouseCode,
        availableDeliveryText,
        availableDeliveryIcon,
        checkDeliveryAvailability,
        setDeliveryStatus,
        setNearestStore,
        resetDeliveryStatus,
    };
} 